import { Suspense } from "react";
import { BrowserRouter } from "react-router-dom";
import { AppRoutes } from "./router";
import { I18nextProvider } from "react-i18next";
import i18n from "./i18n";
import { ShopStoreProvider } from "./hooks/useShopStore";
import { EventStoreProvider } from "./hooks/useEventStore";
import { ScrollToTop } from "./components/feature/ScrollToTop";
import { GlobalPlayerProvider } from "./hooks/useGlobalPlayer";
import { GlobalPlayer } from "./components/feature/GlobalPlayer";
import GlobalAnnouncement from "./components/feature/GlobalAnnouncement";
import { Elements } from '@stripe/react-stripe-js';
import { getStripe } from './lib/stripe';
import { ErrorBoundary } from "./components/feature/ErrorBoundary";

const stripePromise = getStripe();

function App() {
  return (
    <ErrorBoundary>
      <I18nextProvider i18n={i18n}>
        <Elements stripe={stripePromise}>
          <GlobalPlayerProvider>
            <ShopStoreProvider>
              <EventStoreProvider>
                <BrowserRouter basename={__BASE_PATH__}>
                  <GlobalAnnouncement />
                  <ScrollToTop />
                  <main className="bg-black min-h-screen w-full">
                    <Suspense fallback={
                      <div className="flex h-screen w-screen items-center justify-center bg-black">
                        <div className="h-8 w-8 animate-spin rounded-full border-2 border-white border-t-transparent"></div>
                      </div>
                    }>
                      <AppRoutes />
                    </Suspense>
                  </main>
                  <GlobalPlayer />
                </BrowserRouter>
              </EventStoreProvider>
            </ShopStoreProvider>
          </GlobalPlayerProvider>
        </Elements>
      </I18nextProvider>
    </ErrorBoundary>
  );
}

export default App;